import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var IndesignSvg = function IndesignSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#49021F",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F36",
    d: "M9.252 16.167V7.732H7.835v8.435zm3.944.116c1.289 0 1.797-.775 1.983-1.353l.158 1.237h1.05V7.499h-1.43v3.517c-.245-.46-.898-.998-1.89-.998-1.592 0-2.432 1.22-2.432 3.104 0 2.024.963 3.162 2.56 3.162m.292-1.044c-.922 0-1.447-.735-1.447-2.152 0-1.423.607-2.013 1.464-2.013 1.003 0 1.44.7 1.452 2.013 0 1.54-.449 2.152-1.47 2.152"
  }));
};
export var Indesign = function Indesign(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: IndesignSvg
  }));
};